import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

export interface CalendarDatePickerProps {
  date: string | undefined;
  setDate: (date: string | undefined) => void;
  className?: string;
  isDarkMode?: boolean;
}

export function CalendarDatePicker({
  date,
  setDate,
  className,
  isDarkMode,
}: CalendarDatePickerProps) {
  const parsedDate: Date | undefined = date ? new Date(date) : undefined;

  const handleSelect = (selectedDate: Date | undefined) => {
    const formattedDate = selectedDate ? format(selectedDate, "yyyy-MM-dd") : undefined;
    setDate(formattedDate);
  };

  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={"outline"}
            className={cn(
              "w-full justify-start text-left font-normal",
              !date && "text-muted-foreground",
              isDarkMode ? "bg-gray-700 border-gray-600 text-gray-200" : ""
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date ? (
              format(new Date(date), "LLL dd, y")
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent
          className={cn(
            "w-auto p-0",
            isDarkMode ? "bg-gray-800 border-gray-700" : ""
          )}
          align="end"
        >
          <Calendar
            initialFocus
            mode="single"
            defaultMonth={parsedDate}
            selected={parsedDate}
            onSelect={handleSelect}
            numberOfMonths={1}
            disabled={{ after: new Date() }}
            className="p-3 pointer-events-auto"
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}